import { StandardSlideSt } from 'app/shared/components/MediaGallery/components/MediaSlider/components/StandardSlides/StandardSlides.css';
import MediaSlide from 'app/shared/components/MediaGallery/components/MediaSlider/components/StandardSlides/components/MediaSlideList/components/MediaSlide/MediaSlide';
import { usePlayMedia } from 'app/providers/PlayVideoProvider';

const MediaSlideList = ({
  items,
  onImageSlideClick,
  withBackground,
  offset,
}) => {
  const { fullScreenAndPlay } = usePlayMedia();

  return items.map(({ mediaType, alt, original }, index) => {
    if (fullScreenAndPlay) {
      onImageSlideClick(index);
    }
    return (
      <StandardSlideSt
        data-qa={`image-gallery-slide-${index}`}
        key={index}
        onClick={() => onImageSlideClick(index)}
        withBackground={withBackground}
        offset={offset}
      >
        <MediaSlide
          mediaType={mediaType}
          alt={alt}
          original={original}
          withBackground={withBackground}
        />
      </StandardSlideSt>
    );
  });
};

export default MediaSlideList;
